 <template>
  <div>
    <div class="wrap" v-for="(item,index) in data" :key="index"  @click="Jump(item.id)">
      <div class="header">
        <div class="title">
          <div class="titleName">{{item.time}}</div>
          <div class="orderState">{{item.state}}</div>
        </div>
      </div>
      <div class="content">
        <div class="orderImg">
          <img :src="item.img | thumbnail(176,176)">
        </div>
        <div class="info">
          <p>{{item.name}}</p>
          <p>x{{item.num}}</p>
        </div>
      </div>
      <div class="footers">
        <p class="total">
          商品金额:
          <span>￥{{item.price}}</span>
        </p>
        <p class="total">
          订单实付金额:
          <span>￥{{item.pay}}</span>
        </p>
        <button class="footerBtn">查看详情</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  methods: {
    Jump(id) {
      this.$emit("Jump", id);
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../style/skin.less");
.wrap {
  margin-top: 12px;
  background: @white;
  .header {
    border-bottom: 1px solid @veryLightLine;
    .title {
      padding: 8px 15px;
      overflow: hidden;
      height: 30px;
      .titleName {
        float: left;
        font-size: 14px;
        color: @darkP;
        line-height: 20px;
      }
      .orderState {
        float: right;
        font-size: 16px;
        color: @text;
        line-height: 20px;
      }
    }
    .orderMsg {
      padding: 8px 15px;
      overflow: hidden;
      .orderId {
        float: left;
        font-size: 12px;
        color: @lightP;
      }
      .orderTime {
        float: right;
        font-size: 12px;
        color: @lightP;
      }
    }
  }
  .content {
    padding: 8px 15px;
    overflow: hidden;
    border-bottom: 1px solid @veryLightLine;
    .orderImg {
      width: 80px;
      height: 80px;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      float: right;
      width: calc(100% - 80px);
      p:first-child {
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        color: @darkP;
      }
      p:last-child {
        font-size: 14px;
        color: @lightP;
        text-align: right;
      }
    }
  }
  .footers {
    padding: 8px 10px;
    overflow: hidden;
    .total {
      text-align: right;
      font-size: 14px;
      span {
        color: @text;
      }
    }
    .footerBtn {
      float: right;
      color: @darkP;
      border: 1px solid @lightP;
      background: transparent;
      font-size: 14px;
      border-radius: 4px;
      margin-top: 5px;
    }
  }
}
</style>